import $ from 'jquery';
import submitForm from '../../shared/submitForm';
import jsonFormData from '../../../utils/jsonFormData';

const DEVICE_SELECTION_FORM_SELECTOR = '[data-device-selection-form]';

function submitDeviceSelectionWithFeatureData (e) {
  e.preventDefault();
  const $form = $(this)[0];
  const data = jsonFormData($form);

  submitForm($form, {
    processData: true,
    contentType: 'application/json; charset=utf-8',
    data: JSON.stringify(data),
  })
    .done(() => {
      window.location.assign($form.getAttribute('data-redirect-to'));
    })
    .fail((error) => {
      if (window.Rollbar) {
        window.Rollbar.error(error);
      }
      console.error(error);
      window.alert('Oops! Something went wrong.  Please try again or refresh your browser.');
    });
}

export default function attachDeviceSelectionContext () {
  $(document).on('submit', DEVICE_SELECTION_FORM_SELECTOR, submitDeviceSelectionWithFeatureData);
}
